// libreria para hacer peticion al API

export async function apiFetch(url, options = {}) {
  const token = localStorage.getItem("jwt");

  const res = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
      ...(options.headers || {}),
    },
  });

  if (res.status === 401) { // envia al usuario a la pagina de inico. Borra tocken de la memoria del browser
    localStorage.removeItem("jwt");
    window.location.href = "/";
    return; // detiene la ejecucion
  }

  return res;
}

export async function apiFetchJson(url, options = {}) {
  const res = await apiFetch(url, options);
  if (!res) return null; 
  try {
    return await res.json();
  } catch (err) {
    console.warn(`Failed to parse JSON from ${url}:`, err);
    return null;
  }
}